import React from 'react';
import { Switch, Route, Redirect, Link, withRouter, matchPath } from 'react-router-dom';
import {
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import Customer from './customer';
import PendingProductInstance from './pending-product-instance';
import ProvisionPendingProductInstance from './pending-product-instance/provision';
import ProductInstance from './product-instance';
import User from './user';
import UserCreate from './user/create';
import Map from './map';
import Inspector from './inspector';
import Comm from './comm/table';
import Reporting from './report';
import Applications from './applications/table';
import ApplicationPermissions from './applications/permissions';
import ApplicationVersions from './applications/versions';
import ApplicationsInstancesTableScreen from "./applications/instances";
import Sidebar from 'react-sidebar';
import { classes } from './styles';
import CurrentApplicationLabel from './applications/current-label';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IS_DEVELOPMENT } from '../services/config';
import { withPermissions } from '../services/permissions';

class App extends React.Component {

  state = {

  };

  onLogout = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.onLogout();
  };

  getApplicationName(uuid) {

  }

  getSidebar() {
    const instancesActive = !!matchPath(this.props.location.pathname, {
      path: "/applications/instances",
      exact: false
    });
    return (
      <Nav className={`ml-auto ${classes.sidebar}`} navbar vertical>
        {
          [
            {
              permission: 'View Pending Product Instances',
              to: '/pending-product-instance',
              name: 'Pending Product Instance'
            },
            {
              permission: 'View Product Instances',
              to: '/product-instance',
              name: 'Product Instance'
            },
            {
              permission: 'View Customers',
              to: '/customer',
              name: 'Customer'
            },
            {
              permission: 'View Users',
              to: '/user',
              name: 'User'
            },
            {
              permission: 'View Map',
              to: '/map',
              name: 'Map'
            },
            {
              permission: 'View Inspector',
              to: '/inspector',
              name: 'Inspector'
            },
            {
              permission: 'View Comm',
              to: '/comm',
              name: 'Comm'
            },
            {
              permission: 'View Reports',
              to: '/report',
              name: 'Reports'
            },
            IS_DEVELOPMENT && {
              permission: 'View Applications',
              to: '/applications',
              name: 'Applications',
              children: [
                {
                  ignoreInstances: true,
                  permission: 'View Application Instances',
                  hiddenUnless: '/applications',
                  to: '/applications/instances',
                  name: (
                    <React.Fragment>
                      Instances
                    </React.Fragment>
                  )
                },
                {
                  permission: 'View Application Instances',
                  hiddenUnless: '/applications/:uuid',
                  getUrl: ({ params }) => `/applications/${params.uuid}/instances`,
                  to: '/applications/:uuid/instances',
                  name: (
                    <React.Fragment>
                      <CurrentApplicationLabel />&nbsp;Instances
                    </React.Fragment>
                  )
                },
                {
                  permission: 'View Application Permissions',
                  hiddenUnless: '/applications/:uuid',
                  getUrl: ({ params }) => `/applications/${params.uuid}/permissions`,
                  to: '/applications/:uuid/permissions',
                  name: (
                    <React.Fragment>
                      <CurrentApplicationLabel />&nbsp;Permissions
                    </React.Fragment>
                  )
                },
                {
                  permission: 'View Application Versions',
                  hiddenUnless: '/applications/:uuid',
                  getUrl: ({ params }) => `/applications/${params.uuid}/versions`,
                  to: '/applications/:uuid/versions',
                  name: (
                    <React.Fragment>
                      <CurrentApplicationLabel />&nbsp;Versions
                    </React.Fragment>
                  )
                }
              ]
            }
          ]
            .filter(value => {
              if (!value) {
                return false;
              }
              return typeof value.permission !== 'string' || this.props.hasPermission(value.permission);
            })
            .map(
              ({ to, name, children = [] }, index) => {
                const active = !!matchPath(this.props.location.pathname, {
                  path: to,
                  exact: false
                });
                const childNodes = children
                  .filter(value => {
                    if (!value) {
                      return false;
                    }
                    return typeof value.permission !== 'string' || this.props.hasPermission(value.permission);
                  })
                  .map(
                    ({ to, name, useLocation, hiddenUnless, getUrl, ignoreInstances }, index) => {
                      const innerActive = !!matchPath(this.props.location.pathname, {
                        path: to,
                        exact: false
                      });
                      const matchHidden = (ignoreInstances || !instancesActive) && hiddenUnless && matchPath(this.props.location.pathname, {
                        path: hiddenUnless,
                        exact: false
                      });
                      if (!matchHidden) {
                        return null;
                      }
                      return (
                        <NavItem key={index} className={`${classes.sidebarItem} ${classes.sidebarSubItem}`} active={innerActive}>
                          <NavLink to={getUrl && matchHidden ? getUrl(matchHidden) : useLocation ? this.props.location.pathname : to} tag={Link}>
                            <FontAwesomeIcon icon={faArrowRight} />&nbsp;{name}
                          </NavLink>
                        </NavItem>
                      )
                    }
                  );
                const isChildren = childNodes
                  .filter(value => value)
                  .length > 0;
                return (
                  <React.Fragment key={index}>
                    <NavItem className={`${classes.sidebarItem} ${isChildren ? classes.sidebarParentItem : ''}`} active={active}>
                      <NavLink to={to} tag={Link}>
                        {name}
                      </NavLink>
                    </NavItem>
                    {
                      childNodes
                    }
                  </React.Fragment>
                )
              }
            )
        }
      </Nav>
    )
  }

  isMap() {
    return (this.props.location.pathname || '').indexOf('map') > -1;
  }

  render() {
    return (
      <React.Fragment>
        <div className={classes.header}>
          <Link to="/" className={classes.headerBrand}>
            <img className="brand" src="/assets/images/rewards-logo-color.png" />&nbsp;&nbsp;Rewards
          </Link>
          <div>
            <Link to="/logout" onClick={this.onLogout}>Logout</Link>
          </div>
        </div>
        <div className={classes.app}>
          <Sidebar
            shadow={false}
            sidebar={this.getSidebar()}
            docked={!this.isMap()}
          >
            <div className={classes.content}>
              <Switch>
                <Route path="/map" component={Map} />
                <Route path="/customer" component={Customer} />
                <Route path="/pending-product-instance/provision" exact component={ProvisionPendingProductInstance} />
                <Route path="/pending-product-instance/provision/:from" exact component={ProvisionPendingProductInstance} />
                <Route path="/pending-product-instance" exact component={PendingProductInstance} />
                <Route path="/product-instance" component={ProductInstance} />
                <Route path="/inspector" component={Inspector} />
                <Route path="/user/create" exact component={UserCreate} />
                <Route path="/user" exact component={User} />
                <Route path="/comm" exact component={Comm} />
                <Route path="/report" exact component={Reporting} />
                <Route path="/applications" exact component={Applications} />
                <Route path="/applications/instances" exact component={ApplicationsInstancesTableScreen} />
                <Route path="/applications/:uuid/instances" exact component={ApplicationsInstancesTableScreen} />
                <Route path="/applications/:uuid/permissions" exact component={ApplicationPermissions} />
                <Route path="/applications/:uuid/versions" exact component={ApplicationVersions} />
                <Route
                  path="/logout"
                  render={() => {
                    this.onLogout(null);
                    return <p>Redirecting...</p>
                  }}
                />
                <Redirect to="/pending-product-instance" />
              </Switch>
            </div>
          </Sidebar>
        </div>
      </React.Fragment>
    );
  }

}

export default withRouter(withPermissions(App));



// WEBPACK FOOTER //
// ./src/app/app.js